export const smarticoScript = (libraryUrl: string) => `!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    t.onload = function () {
      execCactusEvents('smartico');
    };
    f.parentNode.insertBefore(t, f);
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  "${libraryUrl}",
  "smartico_script"
);
`;
